import { AndYouData } from "../../../sanity/lib/queries/getAndYouData";
import { ImageElement } from "../Image";

interface Props {
    data: AndYouData["andYou"];
    asset: AndYouData["andYou"]["andYouLettering"][number]["image"];
    idx: number;
    setIdx: (index: number) => void;
    updateBackgroundColor: (index: number) => void;
}

export const AndYou = ({ data, updateBackgroundColor, asset, idx, setIdx }: Props) => {
    return (
        <section className="container overflow-hidden" title="and you?">
            <div className="mx-2.5 md:mx-5 py-20 md:pt-20 md:mt-4 md:pb-24">
                <div
                    className="m-display-1 leading-[120%] md:d-display-1 relative inline-block"
                    onMouseEnter={() => {
                        const newIdx = idx === data.andYouLettering.length - 1 ? 0 : idx + 1;
                        setIdx(newIdx);
                        updateBackgroundColor(newIdx);
                    }}
                    onClick={() => {
                        const newIdx = idx === data.andYouLettering.length - 1 ? 0 : idx + 1;
                        setIdx(newIdx);
                        updateBackgroundColor(newIdx);
                    }}
                >
                    {data.title.split(" you?")[0]}

                    {asset && (
                        <div className="h-[128%] md:h-[200%] absolute top-1/2 -translate-y-1/2 translate-x-full aspect-[622/327] -right-3 md:-right-[16%]">
                            <ImageElement
                                loading="lazy"
                                src={asset}
                                width={1000}
                                className="h-full"
                            />
                        </div>
                    )}
                </div>

                <div className="mt-16 md:mt-36">
                    <h2 className="mb-6 m-body-l md:d-body-l">{data.description}</h2>
                    <div className="flex flex-col gap-6">
                        <div>
                            <a
                                href={`mailto:${data.email?.emailAddress}`}
                                className="underline hover:no-underline m-link-xl md:d-headline-1"
                            >
                                {data.email?.label}
                            </a>
                        </div>
                        <div>
                            <a
                                href={`tel:${data.phone}`}
                                className="underline hover:no-underline m-link-xl md:d-headline-1"
                            >
                                {data.phone}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
